"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.healthResponseSchema = exports.healthCheckSchema = void 0;
const zod_1 = require("zod");
/**
 * `GET /health`.
 *
 * It exists in C0 for one reason beyond monitoring: it is the **proof that the seam
 * works** — one schema, validated by the server and inferred by the client, across a
 * CommonJS package boundary and a Vite pre-bundle. If this round-trips, the skeleton is
 * real. If it does not, nothing built on top of it would have worked either.
 *
 * ⚠️ `checks` is deliberately open-ended rather than a fixed object. C4 adds a database
 * check and possibly Redis; a closed shape would make each of those a change to this
 * schema and therefore to both consumers.
 */
exports.healthCheckSchema = zod_1.z.object({
    status: zod_1.z.enum(['ok', 'degraded', 'down']),
    reason: zod_1.z.string().nullable(),
    duration_ms: zod_1.z.number().nullable(),
});
exports.healthResponseSchema = zod_1.z.object({
    status: zod_1.z.enum(['ok', 'degraded', 'down']),
    version: zod_1.z.string(),
    uptime_seconds: zod_1.z.number(),
    checks: zod_1.z.record(zod_1.z.string(), exports.healthCheckSchema),
    /**
     * ⚠️ **Which compiled build this process is RUNNING, not which one is on disk.** A long-lived
     * `node dist/main.js` keeps the code it loaded at boot; rebuild beside it and it answers with an
     * arbitrary earlier commit while the files are current. `api:fresh` compares this against the
     * disk and says so. See `apps/api/src/build-info.ts` for why it is a content hash.
     */
    build: zod_1.z.object({
        /** 12 hex characters, over every compiled `.js` file's path and contents. */
        fingerprint: zod_1.z.string(),
        files: zod_1.z.number().int().nonnegative(),
    }),
});
//# sourceMappingURL=health.js.map